import {ParseResult} from './markdown';
import {skipNulls} from '../skip-nulls';

const inlineTags = [
	// врезной заголовок бывает только в начале абзаца: в середине строки это обычный текст
	{type: 'inlineHeading', pattern: '^\\[ih\\](?<inlineHeading>.+?)\\[\\/ih\\]', content: (match: RegExpMatchArray) => match[1]},
	{type: 'bold', pattern: '(?<!\\\\)\\*(?<bold>.+?)(?<!\\\\)\\*', content: (match: RegExpMatchArray) => match[1]},
	{type: 'italic', pattern: '_(?<italic>.+?)_', content: (match: RegExpMatchArray) => match[1]},
	{
		type: 'link',
		pattern: '\\[(?<linkTitle>.+?)\\]\\((?<linkUrl>.+?)\\)',
		content: (match: RegExpMatchArray) => match[1],
	},
];

function dataByPocketName(pockets: Record<string, string | undefined>) {
	const keys = Object.keys(skipNulls(pockets));
	for (let key of keys) {
		switch (key) {
			case 'inlineHeading':
				return {
					tag: 'inlineHeading',
					content: pockets[key],
				};
			case 'bold':
				return {
					tag: 'b',
					content: pockets[key],
				};
			case 'italic':
				return {
					tag: 'i',
					content: pockets[key],
				};
			case 'linkTitle': {
				const url = pockets['linkUrl']!;
				// обычная ссылка: адрес в разметке уже готовый, маршрут по нему не собрать
				const external = /^[a-z]+:\/\//i.test(url);
				const file = url.startsWith('/images/files/');
				return {
					tag: 'a',
					content: pockets[key],
					props: external
						? {href: url, target: '_blank', rel: 'noreferrer'}
						: file
							? {href: url, download: ''}
							: {href: url},
				};
			}
		}
	}
}

function replaceMarkdownTags(text: string): {children?: ParseResult[]; content?: string} {
	const result: ParseResult[] = [];
	let lastIndex = 0;
	let hasMatches = false;

	const fullRegexp = new RegExp(`(${inlineTags.map((tag) => tag.pattern).join('|')})`, 'g');

	if (text.match(fullRegexp)) {
		hasMatches = true;
		text = text.replaceAll(fullRegexp, (...props) => {
			const match = props[0];
			const pockets = props.at(-1);
			const index = props.at(-3);

			const before = text.slice(lastIndex, index || 0);
			if (before) {
				result.push({tag: 'TextNode', content: before});
			}
			const data = dataByPocketName(pockets);
			if (data) result.push({tag: data.tag, content: data.content, props: data.props});
			lastIndex = index + match.length;
			return match;
		});
		const end = text.slice(lastIndex);
		if (end) {
			result.push({tag: 'TextNode', content: end});
		}
	}

	const resultChildren = hasMatches
		? (result
				.map((child) => {
					if (child.content) {
						const {children, content} = replaceMarkdownTags(child.content);
						return {...child, children, content} as ParseResult;
					}
				})
				.filter(Boolean) as ParseResult[])
		: result;

	return {
		children: resultChildren.length ? resultChildren : undefined,
		content: resultChildren.length ? undefined : text || undefined,
	};
}

export function parseInlineTags(tree: ParseResult[]) {
	const result: ParseResult[] = [];
	for (let item of tree) {
		let newChildren: ParseResult[] = [];
		let newContent: string = '';
		if (item.children) {
			newChildren = parseInlineTags(item.children);
		} else if (item.content) {
			const {children, content} = replaceMarkdownTags(item.content);
			if (children) newChildren = children;
			if (content) newContent = content;
		}
		result.push({
			...item,
			children: newChildren.length ? newChildren : undefined,
			content: newContent || undefined,
		});
	}

	return result;
}
